import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { fetchCurrentUser, sendVerificationEmail } from '../../ducks/user.duck';
import { Logo } from '../../components';

import {
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperAccountSettingsSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  // Footer,
  Page,
  UserNav,
} from '../../components';
import { TopbarContainer } from '../../containers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  saveContactDetails,
  saveContactDetailsClear,
  resetPassword,
} from './DeleteAccountPage.duck';
import css from './DeleteAccountPage.css';
import Modal from '../../components/Modal/Modal';
import { deactivateAccount } from '../../util/api';

class DeleteAccountPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      error: false,
      inProcess: false,
      completed: false,
    };
  }

  render() {
    const handleClose = () => {
      this.setState({ show: false });
    };
    const handleShow = () => {
      this.setState({ show: true });
    };
    const submitHandler = async () => {
      this.setState({ inProcess: true });
      let response = await deactivateAccount({});
      if (response.status === 'success') {
        handleClose();
        this.setState({ inProcess: false, completed: true });
      } else {
        handleClose();
        this.setState({ inProcess: false, error: true });
      }
    };
    const {
      // saveEmailError,
      // savePhoneNumberError,
      // saveContactDetailsInProgress,
      currentUser,
      // contactDetailsChanged,
      // onChange,
      scrollingDisabled,
      // sendVerificationEmailInProgress,
      // sendVerificationEmailError,
      // onResendVerificationEmail,
      // onSubmitContactDetails,
      // onResetPassword,
      // resetPasswordInProgress,
      // resetPasswordError,
      intl,
    } = this.props;

    const user = ensureCurrentUser(currentUser);
    // const protectedData = user.attributes.profile.protectedData || {};

    const deactivationButton = user.id ? (
      <button className={css.submitButton} type="button" onClick={handleShow}>
        <FormattedMessage id="DeleteAccountPage.saveChanges" />
      </button>
    ) : null;

    const DeactivationModal = (
      <Modal
        id="AuthenticationPage.tos"
        isOpen={this.state.show}
        onClose={handleClose}
        onManageDisableScrolling={() => console.log('Confirmation box loaded')}
        usePortal={false}
      >
        <Logo
          format="desktop"
          alt={intl.formatMessage({ id: 'TopbarDesktop.logo' })}
          style={{ marginBottom: '7px' }}
        />

        <div className={css.textWrapper}>
          <FormattedMessage id="DeleteAccountPage.confirmation" />
        </div>

        <div className="buttonbox">
          <button className={css.submitButtonYes} type="button" onClick={submitHandler}>
            <FormattedMessage id="DeleteAccountPage.yes" />
          </button>

          <button className={css.submitButtonEmpty} type="button" onClick={handleClose}>
            <FormattedMessage id="DeleteAccountPage.no" />
          </button>
        </div>
      </Modal>
    );

    const title = intl.formatMessage({ id: 'ContactDetailsPage.title' });

    const userVerification = ensureCurrentUser(currentUser);

    const verification = ensureCurrentUser(userVerification.attributes.profile.protectedData);
    const partner = verification.type;

    return (
      <Page title={title} scrollingDisabled={scrollingDisabled}>
        <LayoutSideNavigation>
          <LayoutWrapperTopbar>
            <TopbarContainer
              currentPage="DeleteAccountPage"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
            <UserNav partner={partner} selectedPageName="DeleteAccountPage" />
          </LayoutWrapperTopbar>
          <LayoutWrapperAccountSettingsSideNav partner={partner} currentTab="DeleteAccountPage" />
          <LayoutWrapperMain>
            <div className={css.content}>
              <h1 className={css.title}>
                <FormattedMessage id="DeleteAccountPage.heading" />
              </h1>
              {this.state.completed ? (
                <FormattedMessage id="DeleteAccountPage.success" />
              ) : this.state.error ? (
                <FormattedMessage id="DeleteAccountPage.error" />
              ) : (
                <FormattedMessage id="DeleteAccountPage.text" />
              )}
              {!this.state.completed ? deactivationButton : null}
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>{/* <Footer /> */}</LayoutWrapperFooter>
        </LayoutSideNavigation>
        {DeactivationModal}
      </Page>
    );
  }
}

DeleteAccountPageComponent.defaultProps = {
  saveEmailError: null,
  savePhoneNumberError: null,
  currentUser: null,
  sendVerificationEmailError: null,
  resetPasswordInProgress: false,
  resetPasswordError: null,
};

const { bool, func } = PropTypes;

DeleteAccountPageComponent.propTypes = {
  saveEmailError: propTypes.error,
  savePhoneNumberError: propTypes.error,
  saveContactDetailsInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  contactDetailsChanged: bool.isRequired,
  onChange: func.isRequired,
  onSubmitContactDetails: func.isRequired,
  scrollingDisabled: bool.isRequired,
  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  onResendVerificationEmail: func.isRequired,
  resetPasswordInProgress: bool,
  resetPasswordError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
  const {
    saveEmailError,
    savePhoneNumberError,
    saveContactDetailsInProgress,
    contactDetailsChanged,
    resetPasswordInProgress,
    resetPasswordError,
  } = state.ContactDetailsPage;
  return {
    saveEmailError,
    savePhoneNumberError,
    saveContactDetailsInProgress,
    currentUser,
    contactDetailsChanged,
    scrollingDisabled: isScrollingDisabled(state),
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    resetPasswordInProgress,
    resetPasswordError,
  };
};

const mapDispatchToProps = dispatch => ({
  onChange: () => dispatch(saveContactDetailsClear()),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onSubmitContactDetails: values => dispatch(saveContactDetails(values)),
  onResetPassword: values => dispatch(resetPassword(values)),
});

const DeleteAccountPage = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(DeleteAccountPageComponent);

DeleteAccountPage.loadData = () => {
  // Since verify email happens in separate tab, current user's data might be updated
  return fetchCurrentUser();
};

export default DeleteAccountPage;
